import React from 'react'

const BestSellingProducts:React.FC = () => {
  return (
    <div className='campaign__container'>
        <div className="campaign__wrapper">
            <img src="/img/widgets/best-selling.png" alt=''/>
        </div>
    </div>
  )
}

export default BestSellingProducts